import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Carousel, Slide } from '@uhg-abyss/web/ui/Carousel';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Card } from '@uhg-abyss/web/ui/Card';
import { getFeature } from '../../redux/tools/features';
import { event } from '@uhg-abyss/web/tools/event';
import { styled } from '@uhg-abyss/web/tools/styled';

const SlideWrapper = styled(Slide, {
  color: '$gray8 !important',
});

export const TabComponent = ({ component, rightRails, tabName, ...props }) => {
  const breakPoint = 1292;
  const [isGreaterThanBreakPoint, setIsGreaterThanBreakPoint] = useState(false);

  useEffect(() => {
    function updateViewPort() {
      if (window.innerWidth > breakPoint) {
        setIsGreaterThanBreakPoint(true);
      } else {
        setIsGreaterThanBreakPoint(false);
      }
    }
    window.addEventListener('resize', updateViewPort);
    updateViewPort();
    return () => window.removeEventListener('resize', updateViewPort);
  }, []);

  const slideItems = rightRails.map((item) => {
    return <SlideWrapper>{item}</SlideWrapper>;
  });
  const slideNavigationHandler = (interactionValue) => {
    event('RIGHT_RAIL_SLIDE_NAVIGATION_CLICK', {
      interactionValue,
      interactionName: tabName,
    });
  };

  const RightRailsSlider = () => {
    return (
      <Carousel
        css={{
          'abyss-carousel-root': {
            minWidth: '350px',
            border: '1px solid $gray4',
            '@media (max-width: 1380px)': {
              minWidth: '325px',
            },
            '@media (max-width: 1310px)': {
              minWidth: '320px',
            },
          },
          'abyss-carousel-controls': {
            backgroundColor: '$gray1',
            borderTop: '1px solid $gray4',
            padding: '2px 8px',
          },
        }}
        slides={slideItems}
        compact
        variant="white"
        nextSlideOnClick={() => slideNavigationHandler('right arrow click')}
        prevSlideOnClick={() => slideNavigationHandler('left arrow click')}
        slideIndexOnClick={(index) =>
          slideNavigationHandler(`slide ${index + 1} click`)
        }
      />
    );
  };

  const RightRailOnePage = () => {
    return (
      <Card
        css={{
          'abyss-card-root': {
            height: '650px',
          },
        }}
        {...props}
      >
        {rightRails[0]}
      </Card>
    );
  };

  return (
    <React.Fragment>
      <Grid align="stretch">
        <Choose>
          <When
            condition={
              getFeature('RIGHT_RAIL_OVERALL') && isGreaterThanBreakPoint
            }
          >
            <Grid.Col span="60%">{component}</Grid.Col>
            <Grid.Col span="40%" style={{ height: '650px' }}>
              <Choose>
                <When condition={rightRails.length === 1}>
                  <RightRailOnePage />
                </When>
                <Otherwise>
                  <RightRailsSlider />
                </Otherwise>
              </Choose>
            </Grid.Col>
          </When>
          <Otherwise>
            <Grid.Col span="100%">{component}</Grid.Col>
          </Otherwise>
        </Choose>
      </Grid>
    </React.Fragment>
  );
};

TabComponent.propTypes = {
  component: PropTypes.node.isRequired,
  rightRails: PropTypes.arrayOf(PropTypes.node).isRequired,
  tabName: PropTypes.string,
};

TabComponent.defaultProps = {
  tabName: '',
};
